import { TranslationService } from './../../../services/translation.service';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  input,
  InputSignal,
  model,
  ModelSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { NotificationsService } from '../../../services';
import { ButtonModule } from 'primeng/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'notifications-inner',
  imports: [ButtonModule,TranslatePipe],
  templateUrl: './notifications-inner.component.html',
  styleUrl: './notifications-inner.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'hidden absolute top-[3.25rem] right-0 w-96 min-h-[325px] bg-surface-0 border border-surface rounded-border origin-top shadow-[0px_3px_5px_rgba(0,0,0,0.02),0px_0px_2px_rgba(0,0,0,0.05),0px_1px_4px_rgba(0,0,0,0.08)]',
  },
})
export class NotificationsInnerComponent {
  translateService = inject(TranslationService);
  notifications: ModelSignal<any> = model.required();

  private notificationService = inject(NotificationsService);

  clearNotifications(notificationId?: string) {
    if (typeof notificationId !== 'undefined') {
      let notificationArr = [];
      notificationArr.push(notificationId);
      const notificationSubscription$ = this.notificationService
        .markAsRead(notificationArr)
        .subscribe({
          next: (val) => {
            //
            this.notifications.update((current) =>
              current.filter((not: any) => not.id != notificationId)
            );
          },
          error(err) {
            console.error(err);
          },
          complete: () => {},
        });
    } else {
      let notificationsId: string[] = [];
      this.notifications().map((notification: any) => {
        notificationsId.push(notification.id);
      });

      const notificationSubscription$ = this.notificationService
        .markAsRead(notificationsId)
        .subscribe({
          next: (val) => {
            this.notifications.set([])
          },
          error(err) {
            console.error(err);
          },
          complete: () => {},
        });
    }
  }
}
